export const baseUrl = `${window.location.origin}/api`;
export const baseDomain = `${window.location.origin}`;
